import { FC } from 'react'
import CustomSelect from '../../UI/CustomSelect/CustomSelect'
import CustomTextArea from '../../UI/CustomTextArea/CustomTextArea'
import TemplateSelect from '../../TemplateSelect/TemplateSelect'
import styles from '../EditClaimCardMainInformation.module.css'
import { CommentTemplateType } from '../../../redux/actions/templatesAction'

interface ServiceItemProps {
  service: any
  index: number
  hotelServices: any[]
  commentTemplates: CommentTemplateType[]
  onServiceNameChange: (index: number, name: string) => void
  onCommentChange: (index: number, comment: string) => void
  onTemplateChange: (index: number, template: CommentTemplateType) => void
  onDelete: (index: number) => void
  onOpenTemplateModal: (serviceId: number, serviceName: string, template?: CommentTemplateType) => void
  onDeleteTemplate: (templateId: number) => void
}

export const ServiceItem: FC<ServiceItemProps> = ({
  service,
  index,
  hotelServices,
  commentTemplates,
  onServiceNameChange,
  onCommentChange,
  onTemplateChange,
  onDelete,
  onOpenTemplateModal,
  onDeleteTemplate,
}) => {
  const selectedService = hotelServices.find((s) => s.name === service.name)
  const serviceTemplates = selectedService
    ? commentTemplates.filter((t) => t.serviceId === selectedService.id)
    : []

  return (
    <div className={styles.eventsBlock}>
      <div className={styles.titleBlockEvent}>Служба {index + 1}</div>
      <div className={styles.rightBlock}>
        <div
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          <CustomSelect
            name={`service-name-${index}`}
            options={hotelServices.map((s) => s.name)}
            value={service?.name || ''}
            onChangeOption={(option) => onServiceNameChange(index, option)}
          />

          {service?.name && selectedService && (
            <div className={styles.templateSelectWrapper}>
              <label className={styles.templateSelectLabel}>
                Выбрать шаблон комментария
              </label>
              <TemplateSelect
                templates={serviceTemplates}
                value={service?.template?.id}
                onChange={(template) => onTemplateChange(index, template)}
                onAdd={() => onOpenTemplateModal(selectedService.id, selectedService.name)}
                onEdit={(template) =>
                  onOpenTemplateModal(selectedService.id, selectedService.name, template)
                }
                onDelete={onDeleteTemplate}
                placeholder='Выберите шаблон...'
              />
            </div>
          )}

          <CustomTextArea
            value={service?.comment || ''}
            callbackHandler={(e) => onCommentChange(index, e.target.value)}
            placeholder='Комментарий'
            withoutFile
          />
          <div>
            <button className={styles.deleteBtn} type='button' onClick={() => onDelete(index)}>
              Удалить службу
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
